import { render, staticRenderFns } from "./ProductInfoAwsDocuments.vue?vue&type=template&id=0d4fe8dd"
import script from "./ProductInfoAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ProductInfoAwsDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d4fe8dd')) {
      api.createRecord('0d4fe8dd', component.options)
    } else {
      api.reload('0d4fe8dd', component.options)
    }
    module.hot.accept("./ProductInfoAwsDocuments.vue?vue&type=template&id=0d4fe8dd", function () {
      api.rerender('0d4fe8dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoAwsDocuments.vue"
export default component.exports